import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/auth/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    const handle = (hasSession) => {
      if (handled.current) return;
      handled.current = true;
      navigate(hasSession ? "/dashboard" : "/login", { replace: true });
    };

    // SIGNED_IN arriva dopo che Supabase ha completato lo scambio del codice PKCE
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_IN" || event === "INITIAL_SESSION") handle(!!session);
      else if (event === "SIGNED_OUT") handle(false);
    });

    // Fallback: sessione già presente (es. refresh della pagina /auth/callback)
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) handle(true);
    });

    return () => subscription.unsubscribe();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-8 h-8 border-2 border-neutral-200 border-t-[color:var(--wf-gold)] rounded-full animate-spin" />
    </div>
  );
}
